'use client';

import { PageMain } from '@/app/(app)/page-main';
import DateRange from '@/components/daterange';
import { cn } from '@/lib/utils';

import { ANALYTICS_AI_COACH_PAGE } from '../nav';
import { CsrDataProvider, useCsrAggregateDataCtx } from './components/board-csr-provider';
import { CSRTable } from './components/csr-table';
import { DashboardStats } from './components/dashboard-stats';

export function AiCoachPage() {
  return (
    <>
      <CsrDataProvider>
        <PageMain title={ANALYTICS_AI_COACH_PAGE.title} right={<DateFilter />}>
          <div className='@container/main space-y-4'>
            <DashboardStats />
            <CallLeaderboard />
          </div>
        </PageMain>
      </CsrDataProvider>
    </>
  );
}

function CallLeaderboard() {
  const { data, isLoading } = useCsrAggregateDataCtx();

  return (
    <div className='space-y-3'>
      <div className='w-full overflow-x-auto'>
        <div
          className={cn('min-w-[900px] overflow-hidden rounded-lg border bg-background', isLoading && 'animate-pulse')}
        >
          <CSRTable data={data} />
        </div>
      </div>
    </div>
  );
}

function DateFilter() {
  const { searchState, setFilters } = useCsrAggregateDataCtx();

  return (
    <DateRange
      onCommit={(range) => {
        if (range?.from && range.to) {
          setFilters({
            ...searchState.filters,
            dateRange: {
              from: range.from,
              to: range.to,
            },
          });
        }
      }}
      applyButton
      applyButtonValidate={(range) => range?.from !== undefined && range?.to !== undefined}
      value={{
        from: new Date(searchState.filters.dateRange.from),
        to: new Date(searchState.filters.dateRange.to),
      }}
    />
  );
}
